import CompanyBranchListMainComponent from "../components/CompanyBranchListMain";
import useCompanyBranchList from "../hooks/useCompanyBranchList";

function CompanyBranchListMain(props) {
  const useCompanyBranchListProps = useCompanyBranchList(props);
  return <CompanyBranchListMainComponent {...useCompanyBranchListProps} />;
}

export default CompanyBranchListMain;
